module.exports = __webpack_public_path__ + "static/media/reestructura.59e69692.svg";